// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/paperclip.js';

import { paths } from '../generated/paperclip';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('paperclip', Original, paths);
